// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-opening-hours[data-v-74c15c87]{margin-bottom:10px}.restaurant-address[data-v-74c15c87],.restaurant-phone-number[data-v-74c15c87],.view-menu-button[data-v-74c15c87]{margin-bottom:25px}.view-menu-button[data-v-74c15c87]{min-width:160px}.half-price-sale[data-v-74c15c87]{color:#e70095}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
